import React from "react";
import { string } from "prop-types";
import Link from "@insightfulscience/atomic-react/Link";
import Icon from "@insightfulscience/atomic-react/Icon";
import UList from "@insightfulscience/atomic-react/UList";

const AcademyToCLink = ({ title, slug }) => {
	return (
		<UList.Item
			sx={{ fontSize: "m" }}
			spacing={{ my: 2 }}
			className="no-li-style"
		>
			<Link
				href={`#${slug}`}
				sx={{ fontColor: "black--custom-1", hover: { fontColor: "3" } }}
			>
				<Icon name="angle-right" /> {title}
			</Link>
		</UList.Item>
	);
};

AcademyToCLink.propTypes = {
	title: string.isRequired,
	slug: string.isRequired,
};

export default AcademyToCLink;
